export default __webpack_public_path__ + "media/images/images/portrait/small/avatar-s-4-c4e1b240c7ddf33b1f7552e3396818a1.png";